module.exports = __webpack_public_path__ + "img/20191116143933360截图20191116143209518.ffcd8144.jpg";